module.exports = __webpack_public_path__ + "static/media/1-pin.06b152de.svg";